export const getUrl = (uri: string) => uri.split('?')[0];
